import { BasicCommand } from "./BasicCommand";
import { DependencyRuleBuilder } from "./DependencyRuleBuilder";
import { DependencyType } from "./DependencyType";
import { OnDeleteOption } from "./OnDeleteOption";

export class DependencyRule {
    principal: string;
    principalKeySelector: (entity: BasicCommand<any>) => any = null;
    dependent: string;
    dependentKeySelector: (entity: BasicCommand<any>) => any = null;
    type: DependencyType;
    onDeleteOption: OnDeleteOption;

    constructor(point: DependencyRuleBuilder<any, any>) {
        this.principal = point.principal;
        this.principalKeySelector = point.principalKeySelector;
        this.dependent = point.dependent;
        this.dependentKeySelector = point.dependentKeySelector;
        this.type = point.type;
        this.onDeleteOption = point.onDeleteOption;
    }

    principalKey = (entity: BasicCommand<any>) => {
        if (this.principalKeySelector) {
            return this.principalKeySelector(entity);
        }
        return entity.primaryKey;
    };

    dependentKey = (entity: BasicCommand<any>) => {
        if (this.dependentKeySelector) {
            return this.dependentKeySelector(entity);
        }
        return entity.primaryKey;
    };
}
